import { Phone, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { BrandPatternLayer } from "@/components/BrandPatternLayer";
import { hotlines, openingHours } from "@/lib/siteConfig";
import { commonContent } from "@/cms/cmsModel";

// The three hotline areas (Gutachten / Versicherung / Zulassung) as direct-dial
// cards, plus the opening hours. Content comes from siteConfig (CMS-ready).
export const HotlineCards = () => {
  const copy = commonContent.hotlines;
  return (
    <section
      className="relative isolate overflow-hidden bg-[#E7EDF5]/90 py-16 lg:py-24"
      data-testid="home-hotlines-section"
    >
      <BrandPatternLayer variant="corporate" composition="a" />
      <div className="relative z-10 az-container">
        <SectionHeading
          align="center"
          eyebrow={copy.eyebrow}
          title={copy.title}
          subtitle={copy.subtitle}
          className="mb-12"
        />
        <div className="grid gap-6 lg:grid-cols-3">
          {hotlines.map((h, i) => (
            <Reveal key={h.id} delay={i * 0.12} className="h-full">
              <a
                href={`tel:${h.tel}`}
                data-testid={`home-${h.id}-hotline-link`}
                className="group flex h-full items-center gap-4 rounded-2xl border border-[#D5DEE8] bg-white p-6 shadow-[var(--shadow-soft)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[var(--shadow-card)]"
              >
                <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-[#7A1516]/[0.08] text-[var(--az-icon-default)] transition-colors duration-300 group-hover:bg-[var(--az-icon-hover)] group-hover:text-white group-focus-visible:bg-[var(--az-icon-hover)] group-focus-visible:text-white">
                  <Phone size={24} />
                </span>
                <span className="min-w-0 flex-1">
                  <span className="block text-sm font-semibold uppercase tracking-[0.14em] text-[#6e7683]">
                    {h.label}
                  </span>
                  <span className="mt-1 block font-heading text-2xl font-bold text-[#193D6D] [overflow-wrap:anywhere]">
                    {h.number}
                  </span>
                </span>
                <ArrowUpRight
                  size={20}
                  className="shrink-0 text-[#7A1516] transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                />
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mx-auto mt-10 flex max-w-2xl flex-col items-center justify-center gap-2 rounded-2xl border border-[#D5DEE8] bg-white/70 px-6 py-5 text-center sm:flex-row sm:gap-8">
            {openingHours.map((o) => (
              <span key={o.days} className="text-[#2f3a49]">
                <span className="font-semibold text-[#193D6D]">{o.days}:</span> {o.time}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
